import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {ModelData} from "features/model/types/test/getTestIdShema";

export interface Answer {
    id: number;
    position: number;
    text: string;
    isCorrect: boolean | null;
    selected: boolean
}


export interface TestItem {
    id: number,
    position: number,
    questionType: string;
    questionTitle: string;
    before: string;
    after: string;
    afterSecond: string;
    file?: {path: string, fileName: string}
    tabType: string,
    answers: Answer[];
}

interface CreateTestFormState {
    title: string;
    selectedGroupIds: number[];
    selectedStudentIds: number[];
    available: number | string;
    testItems: TestItem[];
    published: boolean;
    testData: any,
}


const initialState: CreateTestFormState = {
    title: '',
    selectedGroupIds: [],
    selectedStudentIds: [],
    available: '',
    published: false,
    testItems: [],
    testData: {},
};





const createTestFormSlice = createSlice({
    name: 'createTestForm',
    initialState,
    reducers: {
        setBackData: (state, action: PayloadAction<ModelData>) => {
            state.title = action.payload.title;
            state.selectedGroupIds = action.payload.selectedGroupIds;
            state.selectedStudentIds = action.payload.selectedStudentIds;
            state.available = action.payload.available;

            state.published = action.payload.published;
            state.testItems = action.payload.testItems;

        },
        deleteTestBackData:(state,action) => {
            state.testItems= action.payload
        },
        setTestName: (state, action) => {
            state.title = action.payload;
        },
        setAvailable: (state, action) => {
            state.available = action.payload;
        },
        setGroupIds: (state, action) => {
            state.selectedGroupIds = action.payload;
        },
        setStudentsIds: (state, action) => {
            state.selectedStudentIds = action.payload;
        },

        setTextTabData: (state, action: PayloadAction<TestItem>) => {
            state.testItems = state.testItems.map(item =>
                item.id === action.payload.id ? action.payload : item
            );
        },


        setAnswerOptions: (state, action: PayloadAction<{ testId: number; updatedAnswers: Answer[] }>) => {
            const { testId, updatedAnswers } = action.payload;
            state.testItems = state.testItems.map((item) => {
                if (item.id !== testId) {
                    return item;
                }

                const existingAnswers = item.answers || [];
                const updatedAnswerIds = new Set(updatedAnswers.map(answer => answer.id));

                // Фильтруем существующие ответы, оставляя только те, которые есть в updatedAnswers
                const filteredAnswers = existingAnswers.filter((existingAnswer) => updatedAnswerIds.has(existingAnswer.id));

                // Удаляем ответы, которые не присутствуют в updatedAnswers
                const deletedAnswerIds = existingAnswers
                    .filter(existingAnswer => !updatedAnswerIds.has(existingAnswer.id))
                    .map(existingAnswer => existingAnswer.id);

                // Удаляем ответы из списка
                const updatedItem = {
                    ...item,
                    answers: filteredAnswers.map((filteredAnswer) => {
                        const updatedAnswer = updatedAnswers.find(answer => answer.id === filteredAnswer.id);
                        return updatedAnswer || filteredAnswer;
                    }),
                };

                deletedAnswerIds.forEach(deletedId => {
                    updatedItem.answers = updatedItem.answers.filter(answer => answer.id !== deletedId);
                });

                // Добавляем новые ответы
                updatedItem.answers = updatedAnswers.map((updatedAnswer) => {
                    const existingAnswer = updatedItem.answers.find(answer => answer.id === updatedAnswer.id);
                    return existingAnswer || updatedAnswer;
                });

                return updatedItem;
            });
        },


        setTabActive: (state, action: PayloadAction<{ itemId: number; tabType: string }>) => {
            const { itemId, tabType } = action.payload;
            const index = state.testItems.findIndex(item => item.id === itemId);
            if (index !== -1) {
                state.testItems[index].tabType = tabType;
            }
        },


        addNewQuestion: (state) => {
            const newId = Math.round(Math.random() * 1000);
            const newTestItem: TestItem = {
                id: newId,
                position: state.testItems.length + 1,
                questionType: 'withoutSkipping',
                questionTitle: 'Введите текст вопроса',
                before: '',
                after: '',
                afterSecond: '',
                file: {path: "", fileName: ""},
                tabType: 'textType',
                answers: [],
            };

            // Создайте новый массив testItems и добавьте в него новый элемент
            const updatedTestItems = [...state.testItems, newTestItem];

            // Обновите состояние новым массивом testItems
            state.testItems = updatedTestItems;
        },

    },
});

export const {
    setTestName,
    setAvailable,
    setTabActive,
    setGroupIds,
    setStudentsIds,
    setTextTabData,
    setAnswerOptions,
    addNewQuestion,
    setBackData,
    deleteTestBackData,
} = createTestFormSlice.actions;

export const createTestFormReducer = createTestFormSlice.reducer;

